import React, { useState } from "react";
import View from "views/View";
import ImageEditor from "components/images/editor/ImageEditor";
import ImageGenerator from "components/images/generator/ImageGenerator";
import TokenEditor from "components/images/tokens/TokenEditor";
import { Tab, Tabs, Stack } from "@mui/material";
import QueryLoader from "data/QueryLoader";
import { auth, db } from "firebaseApp";
import { collection, orderBy, query, where } from "firebase/firestore";
// import ModelSelectorMenu from "../components/images/ModelSelectorMenu";
// import CurrentModelHeader from "../components/images/CurrentModelHeader";

export default function ImageStudioView() {
  const [tab, setTab] = useState(0);
  const uid = auth.currentUser?.uid;

  const generatedImagesQuery = uid
    ? query(
        collection(db, "imageGeneration"),
        where("uid", "==", uid),
        orderBy("createdAt", "desc")
      )
    : null;

  return (
    <View
      // renderLeftActions={() => {
      //   return <CurrentModelHeader />;
      // }}
    >
      <QueryLoader name="generatedImages" q={generatedImagesQuery} />
      <Stack
        alignItems="center"
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <Tabs
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
          variant="fullWidth"
          allowScrollButtonsMobile
          sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}
        >
          <Tab label="Image Generator" />
          <Tab label="Image Editor" />
          <Tab label="Token Editor" />
        </Tabs>

        <Stack
          sx={{ flexGrow: 1, overflow: "auto", maxWidth: "lg", width: "100%" }}
        >
          {tab === 0 && <ImageGenerator />}
          {tab === 1 && <ImageEditor />}
          {tab === 2 && <TokenEditor />}
        </Stack>
      </Stack>
    </View>
  );
}
